// extracted by mini-css-extract-plugin
module.exports = {"AboutPage":"AboutPage-module--AboutPage--OTMNr","aboutParagraphContainer":"AboutPage-module--aboutParagraphContainer--2eJUD"};